export default "__VITE_ASSET__b10690c7__"